import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useHistory } from 'src/services/useHistory';
import { isOnboardingFinished } from 'src/utils/extensions/author_complete';
import { customerSubscriptionExpired } from 'src/data/customer';
import { ROUTES } from 'src/routes';
import { useInviteAcceptPopup } from 'src/services/popup';
import { useIsApplicationModeInfinity } from 'src/services';
import useViewState from './useViewState';

const RootPage = () => {
  const history = useHistory();
  const location = useLocation();

  const { currentUser, currentUserLoading, currentCustomer } = useViewState();

  const isInfinityAppMode = useIsApplicationModeInfinity();
  const showInviteAcceptModalIfNeeded = useInviteAcceptPopup();

  const navigateToStartPage = useCallback(
    (onboardingRequired = true) => {
      // Go straight to "infinity page" in case we are in "infinity" app mode
      if (isInfinityAppMode) {
        history.replace(ROUTES.EXTERNAL_INFINITY_EXTENSION);
        return;
      }

      if (onboardingRequired) {
        // HOTFIX: remove query parameter after CREAT-2341 is properly handled from extension side
        history.replace(`${ROUTES.EXTENSION_DEMO}?reload`);
        return;
      }

      showInviteAcceptModalIfNeeded();
      // Navigate to dashboard by default
      history.replace(`${ROUTES.DASHBOARD}${location.search}`);
    },
    [history, location, showInviteAcceptModalIfNeeded, isInfinityAppMode]
  );

  useEffect(() => {
    if (currentUserLoading) {
      return undefined;
    }

    // Navigate to 'email verification' page if needed
    if (currentUser && !currentUser.isConfirmed) {
      history.replace(ROUTES.NOT_VERIFIED);
      return undefined;
    }

    if (!currentCustomer) {
      return undefined;
    }

    if (customerSubscriptionExpired(currentCustomer)) {
      return undefined;
    }

    isOnboardingFinished()
      .then((info) => navigateToStartPage(!info.isFinished))
      .catch(() => navigateToStartPage(false));

    return undefined;
  }, [currentUser, currentUserLoading, currentCustomer, navigateToStartPage, history]);

  return null;
};

export default RootPage;
